<script>
import StepsItem from './StepsItem.vue'
import StepLink from './StepLink.vue'
export default {
  props: {
    activeStep: {
      type: Number,
      default: 0
    },
    /**
     * @description: 步骤列表
     * step数据结构
     * {
     *  name: '步骤名称'
     *  isPass: '是否通过'
     *  isChecked: '是否已检测'
     * }
     */
    steps: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => {
    return {}
  },
  components: {
    StepsItem,
    StepLink
  }
}
</script>
<template>
  <div class="steps-box">
    <template v-for="(step, idx) in steps">
      <StepsItem
        :key="step.name"
        :isActived="activeStep >= idx + 1"
        :num="idx + 1"
        :desc="step.name"
        :isPass="step.isPass"
        :isChecked="step.isChecked"
      />
      <StepLink
        :key="step.name + 'link'"
        :isPass="step.isPass"
        v-if="idx < steps.length - 1"
      />
    </template>
  </div>
</template>
<style scoped>
.steps-box {
  display: flex;
  justify-content: center;
}
</style>
